import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface errors {
  sku: string;
  description: string;
  status: string;
}
@Component({
  selector: 'app-excel-alert-modal',
  templateUrl: './excel-alert-modal.component.html',
  styleUrls: ['./excel-alert-modal.component.scss']
})
export class ExcelAlertModalComponent implements OnInit, OnDestroy {

  dataRecieved: any ;
 
  dataSource : errors[] = []
  readonly displayedColumns: string[] = ['sku', 'description','status'];
  constructor(
    public readonly dialogRef: MatDialogRef<ExcelAlertModalComponent>,
    private readonly renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) data
    ) {
      this.openedStart()
      this.dataRecieved = data;
      if(data.status === 2){
        this.dataSource = data.skuError
      }
    }
  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this.closedStart()
  }


  save(status){
    this.dialogRef.close({status:status});
  }
  onNoClick(){
    this.dialogRef.close(false);
  }
  
  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
  getProductStatus(product: any) {
    if (!product?.error || typeof product.error.type !== 'number') {
      return null; // o alguna lógica para cuando error o type no está definido
    }
    switch (product.error.type) {
      case 6:
        return { class: 'discontinued-label' };
      case 7:
        return { class: 'not-available-label' };
      default:
        return {
          class: 'not-available-label',
          text: 'Error fila ' + product.position,
        };
    }
  }    
  getTextInfo(): string {
    if (this.dataRecieved?.validProductExists) {
      return 'Los productos con <span class="color-green fts-16 font-bold-dali">nueva presentación</span> reemplazarán a los descontinuados correspondientes.';
    } else {
      return '<div class="text-info">Todos tus productos están descontinuados, no disponibles y/o presentan errores.</div>';
    }
  }
  
}
